/** Normalize a SKU string: uppercase and trim whitespace. */

export function normalizeSku(sku: string | null | undefined): string {
  return String(sku ?? '').toUpperCase().trim();
}
